import myImage from './Images/Image2.jpg';
import styled from 'styled-components';
import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom'; // React Router hook
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, postData, fetchData1, updateData, fetchDataActive, fetchDatalist } from "../../apiService";
import { AuthProvider, useAuth } from "../../AuthContext";
import { tokenIsExpired } from "../../authUtils";
import { IconButton, Modal, Button, TextField, MenuItem } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import Select from 'react-select';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import {
  Search as SearchIcon,
  Edit as EditIcon,
  Delete as DeleteIcon
} from '@mui/icons-material';
import { TableCell, TableContainer, Tooltip, Paper, Table, TableHead, TableBody, TableRow } from '@mui/material';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import CircleNotificationsIcon from '@mui/icons-material/CircleNotifications';
import CakeIcon from '@mui/icons-material/Cake';
import CelebrationIcon from '@mui/icons-material/Celebration';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import MessageIcon from '@mui/icons-material/Message';
import axios from 'axios';
import { FaSave } from 'react-icons/fa'; // Importing the save icon from react-icons
//const [MemberFamilyDatas, setMemberFamilyDatas] = useState([]);
import { v4 as uuidv4 } from 'uuid';

// Inline styles
const containerStyle = {
  width: "90%",
  maxWidth: "800px",
  margin: "0 auto",
  textAlign: "center",
  fontFamily: "Arial, sans-serif",
  marginTop: '5%'
};

const cardStyle = {
  background: "#f7f7f7",
  padding: "20px",
  borderRadius: "10px",
  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  marginBottom: "20px",
};

const imageStyle = {
  width: "100px",
  height: "100px",
  borderRadius: "50%",
  marginBottom: "10px",
};

const nameStyle = {
  color: "#2c3e50",
  margin: "5px 0",
};

const subtitleStyle = {
  fontSize: "0.9rem",
  color: "#7f8c8d",
  margin: "5px 0",
};

const bioStyle = {
  color: "#444",
  fontSize: "0.95rem",
  marginTop: "10px",
};


const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  margin: "10px 0",
};


const Home1 = () => {
  //const { id } = useParams();
  const [profilePhoto, setProfilePhoto] = useState(null);
  const [uploadedImageName, setUploadedImageName] = useState('');
  const [firstname, setFirstname] = useState(null);
  const [id, setId] = useState('');
  const [uploadedImageUrl, setUploadedImageUrl] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const history = useHistory();
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [message, setMessage] = useState(''); // For user message input
  const [messages, setMessages] = useState([]); // Store the list of messages
  const [isIdValid, setIsIdValid] = useState(true);
  const { isAuthenticated, clubId, branchId, userId, logout, token } = useAuth();
  const [data, setData] = useState([]);
  const [newRecordData, setNewRecordData] = useState({ Name: '', DateOfBirthChild: '', BloodGroupId: '', Relation: '' });

  const [formData, setFormData] = useState({
    memberId: '',
    category: '',
    firstName: '',
    lastName: '',
    dateOfBirth: '',
    dateOfJoining: '',
    weddingAnniversary: '',
    originalRotaryDate: '',
    proposedByMemberId: '',
    proposedMemberName: '',
    classification: '',
    firmName: '',
    occupation: '',
    address: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    rotaryRecognition: '',
    onlineAccountwithmyRotary: '',
    email: '',
    phoneNumber: '',
    phoneNumber1: '',
    remark: '',
    gender: '',
    bloodGroupId: '',
    bloodGroupName: '',
    dateofleavingfrom: '',
    dateofleavingTo: '',
    expirydate: '',
    status: '',
    admittedDate: '',

  });

  useEffect(() => {
    setNewRecordData({
      Name: '',
      DateOfBirthChild: '',
      BloodGroupId: '',
      Relation: '',
      bloodGroupName: '',
    });
  }, []); // This will run only once when the component mounts

  const [profileguid1, setprofileguid] = useState("");
  const [selectedgroupchild, setselectedgroupchild] = useState("");
  const [bloodGroupOptions, setBloodGroupOptions] = useState([]);
  const [selectedgroup, setSelectedGroup] = useState(null);
  const [isReminderModalOpen, setIsReminderModalOpen] = useState(false);
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [isMessageSending, setIsMessageSending] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [selectedRecord, setSelectedRecord] = useState(null);
  const [MemberFamilyDatas, setMemberFamilyDatas] = useState([]);
  const [fromdate, setFromDate] = useState("");  // From date state
  const [interval, setInterval] = useState(5);  // Default interval is 5 days
  const [childId, setChildId] = useState(0);  // Default interval is 5 days
  const [memberlist, setMemberOptions] = useState([]);

  const location = useLocation();

  useEffect(() => {
    const shouldReload = localStorage.getItem('shouldReload') === 'true';

    // Only reload data if navigated from PurchaseOrderCreate and flag is set
    if (location.state?.from === '/' && shouldReload) {
      localStorage.removeItem('shouldReload'); // Clear the flag after use
      window.location.reload();
    }
   
    else {
    }
  }, [location]);

  useEffect(() => {
    const fetchDataAsync = async () => {
      try {
        fetchBloodGroup();
        fetchMember();
        fetchtableData();

        if (isAuthenticated && tokenIsExpired(token)) {
          logout();
          return;
        }

        if (!userId) {
          setIsIdValid(false);
          setErrorMessage('Invalid ID. Please try again.');
          return;
        }

        const profileResponse = await fetchData('ProfileViewApi', `/GetMemberDetails/${userId}`, token);

        if (profileResponse.responseCode === '1111') {
          const memberDatas = profileResponse.response_data.memberdata;
          const familyDatas = profileResponse.response_data.familydata;

          setFormData({
            ...memberDatas,
            UpdatedBy: userId,
          });
          setFirstname(memberDatas.firstName);
          setId(memberDatas.id);

          const permissionResponse = await fetchData1('ProfileViewApi', `/${clubId}/${branchId}/${memberDatas.id}/0`, token);

          if (permissionResponse?.responsenew) {
            const feeCheckResponse = await fetchData1('ClubFeesApi', `/${clubId}/${branchId}/0`, token);

            if (feeCheckResponse?.response === "1") {
              const confirmResult = window.confirm('Some fees can be generated. Do you want to generate them?');

              if (confirmResult) {
                const generateResponse = await fetchData1('ClubFeesApi', `/${clubId}/${branchId}/1`, token);
                alert('Fees generated successfully!');
              } else {
                alert('Fee generation cancelled.');
              }
            }
          } else {
            console.log('Permission denied');
          }

          if (Array.isArray(familyDatas)) {
            setMemberFamilyDatas(familyDatas);
          } else {
            console.error('Expected an array for familyDatas but got:', familyDatas);
            setMemberFamilyDatas([]);
          }

          const imageUrl = `https://res.cloudinary.com/dm9pk2viy/image/upload/v1/Rotary/member/${memberDatas.branchId}/${memberDatas.firstName}_${memberDatas.id}_${memberDatas.profileguid}.jpg`;
          setProfilePhoto(imageUrl);
          setprofileguid(memberDatas.profileguid);
        } else {
          setIsIdValid(false);
          setErrorMessage('Invalid ID. No record found.');
        }
      } catch (error) {
        console.error('Error fetching Member Details:', error);
        setIsIdValid(false);
        setErrorMessage('Failed to fetch member details.');
      }

      const currentDate = new Date().toISOString().split('T')[0];
      setFromDate(currentDate);
    };

    fetchDataAsync();
  }, [userId, isAuthenticated, token, logout]);

  useEffect(() => {
    const chatContainer = document.querySelector('.overflow-y-auto');
    if (chatContainer) {
      chatContainer.scrollTop = chatContainer.scrollHeight; // Scroll to the bottom
    }
  }, [messages]);

  const handleSendMessage = () => {
    if (message.trim()) {
      setIsConfirmModalOpen(true); // Show confirmation modal
    }
  };

  const handleConfirmSend = (confirm) => {
    if (confirm) {
      // Send the message and close the modal
      submitData();
    }
    setIsConfirmModalOpen(false); // Close the confirmation modal
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSendMessage(); // Trigger send message on Enter key
    }
  };

  const submitData = async () => {
    const MessageChat = {
      ClubId: clubId,
      BranchId: branchId,
      Message: message, // Use message instead of 'name'
      UserId: userId || "",
      PhoneNo: "",
      UserName: "",
      CreatedDate: new Date(),
    };

    try {
      const response = await postData('ProfileViewApi', MessageChat, token);
      console.log('Message Sent:', response);
      setSuccessMessage("Message sent successfully!");
      setMessage("");
      fetchMessages();
      // setMessage("");
      setErrorMessage("");
      setTimeout(() => {
        setSuccessMessage("");
      }, 3000);
      // Optionally reload the window if necessary
      // window.location.reload();
    } catch (error) {
      console.error('Message Send error:', error);
      setErrorMessage("Failed to send the message.");
    }
  };

  const fetchBloodGroup = async () => {
    try {
      const response = await fetchDataActive('MemberApi', token);
      if (response.responseCode === '1111') {
        const options = response.response_data.map((bgroup) => ({
          value: bgroup.id,
          label: bgroup.group,
        }));
        setBloodGroupOptions(options);  // Set the fetched blood group options
      }
    } catch (error) {
      console.error('Error fetching Blood Group:', error);
    }
  };

  const fetchMember = async () => {
    try {
      const params1 = `/${clubId}`;
      const params2 = `?branchId=${branchId}`;
      // const response = await fetchData1('MemberApi', params1, params2, token);
      const response = await fetchData1('MemberApi', `/${clubId}/${branchId}`, token);
      if (response.responseCode === '1111') {

        const options = response.response_data.map(member => ({
          value: member.id,
          label: member.firstName,
        }));
        setMemberOptions(options);
      }
    } catch (error) {
      console.error('Error fetching Member:', error);
    }
  };

  const handleBloodGroupChange = (selectedOption) => {
    setSelectedGroup(selectedOption);
    setFormData((prevData) => ({
      ...prevData,
      bloodGroupId: selectedOption ? selectedOption.value : null,
      bloodGroupName: selectedOption ? selectedOption.label : '',
    }));
  };

  const handleChange = (event) => {
    const { name, value, type } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === 'checkbox' ? !prevData[name] : value,
    }));
  };

  const handleGenderChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value, // Update gender based on the selected value
    }));
  };

  const formatDateForInput = (dateString) => {
    if (!dateString) return ''; // Handle cases where dateString is undefined or null
    const currentDate = new Date(dateString);
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    return `${day}-${month}-${year}`;
  };

  const toggleMessageModal = () => {
    setIsMessageModalOpen(!isMessageModalOpen);
  };

  const toggleMessageModalClose = () => {
    setIsMessageModalOpen(!isMessageModalOpen);
  };

  const toggleReminderModal = () => {
    setIsReminderModalOpen(!isReminderModalOpen);
  };

  const toggleReminderModalClose = () => {
    setIsReminderModalOpen(!isReminderModalOpen);
  };

  const toggleMasterEditModal = () => {
    setIsEditModalOpen(!isEditModalOpen);
  };

  const toggleEditModalClose = () => {
    setIsEditModalOpen(!isEditModalOpen);
  };

  const toggleChildEditModalClose = () => {
    setIsModalOpen(!isModalOpen);
  };

  const toggleChildEditModal = (id, childdata) => {
    setIsModalOpen(!isModalOpen);
    setChildId(id);  // Pre-fill the input field with the current phone number
    setNewRecordData(childdata);
    fetchBloodGroup();
    fetchMember();
  };

  //-------------------------------------------------------------------------------

  const [familyData, setFamilyData] = useState([]);

  // Function to toggle modal for both adding and editing
  const toggleModal = (record = null) => {
    setSelectedRecord(record);
    if (record) {
      setNewRecordData(record); // Prefill with existing data for edit
    } else {
      setNewRecordData({ Name: '', DateOfBirthChild: '', BloodGroupId: '', Relation: '' }); // Clear form for new record
    }
    setIsModalOpen(!isModalOpen);
  };

  // Handle form input changes
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setNewRecordData({ ...newRecordData, [name]: value });
  };

  const addRecord = () => {
    // Add new record to the table
    setFamilyData((prevData) => [...prevData, newRecordData]);

    // Close modal
    setIsModalOpen(false);
  };

  const handleDateOfBirthChange = (event) => {
    setNewRecordData((prevData) => ({
      ...prevData,
      DateOfBirthChild: event.target.value, // Directly update DateOfBirthChild
    }));
  };
  const [isFirstLogin, setIsFirstLogin] = useState(false);

  useEffect(() => {
    // Check if it's the user's first login
    if (!localStorage.getItem('firstLogin')) {
      // Set the first login flag in localStorage
      localStorage.setItem('firstLogin', 'true');
      setIsFirstLogin(true);
    }
  }, []);

  useEffect(() => {
    if (fromdate && interval) {

      fetchtableData();
    }
  }, [fromdate, interval]);  // Dependencies: Recalculate when either 'From date' or 'Interval' changes

  const fetchtableData = async () => {
    try {
      const response = await fetchData1('ProfileViewApi', `/${clubId}/${branchId}/${fromdate}/${interval}/Reminder`, token);

      if (response.responseCode === '1111') {
        console.log('Fetched Data:', response);
        setData(response.response_data);
      } else {
        console.warn('Response indicates an issue:', response);
      }
    } catch (error) {
      if (error.response) {
        console.error('Server Error:', error.response.data);
        console.error('Status Code:', error.response.status);
      } else if (error.request) {
        console.error('No response received:', error.request);
      } else {
        console.error('Unexpected Error:', error.message);
      }
    }
  };

  const handleFamilymemberEditClick = (id) => {


  };

  const handleSubmitMaster
    = async (e) => {
      e.preventDefault();

      const member = {
        Id: formData.id,
        FirstName: formData.firstName || null,  // Pass null if lastname is falsy
        LastName: formData.lastName || null,  // Pass null if firstname is falsy
        WeddingAnniversary: formData.weddingAnniversary || null,  // Null if weddinganniversary is falsy
        DateOfJoining: formData.dateOfJoining || null,  // Null if dateofjoining is falsy
        DateOfBirth: formData.dateOfBirth || null,  // Null if dateofbirth is falsy
        PhoneNumber: formData.phoneNumber || null,  // Null if phonenumber is falsy
        Email: formData.email || null,  // Null if email is falsy
        Remark: formData.remark || null,  // Null if remark is falsy
        CreatedBy: formData.createdBy, // Null if userId is falsy (unlikely for userId)
        CreatedDate: formData.createdDate,  // Always generate the current date
        ModifiedBy: userId,
        ModifiedDate: new Date(),
        BloodGroupId: formData.bloodGroupId,
        Gender: formData.gender || null,  // Null if gender is falsy
        ClubId: clubId, // Null if clubId is falsy
        UserTypeId: 4, // Default to 4 (doesn't need a null check)
        Expirydate: formData.expirydate,
        DateOfLeavingFrom: formData.dateOfLeavingFrom,
        DateOfLeavingTo: formData.dateOfLeavingTo,
        IsLoginNeeded: true,
        Status: formData.status,
        profileguid: profileguid1,
        OriginalRotaryDate: formData.originalRotaryDate,
        ProposedByMemberId: formData.proposedByMemberId,
        Classification: formData.classification,
        FirmName: formData.firmName,
        Occupation: formData.occupation,
        Address: formData.address,
        City: formData.city,
        State: formData.state,
        PostalCode: formData.postalCode,
        Country: formData.country,
        PhoneNumber1: formData.phoneNumber1,
        RotaryRecognitions: null,
        RotaryRecognition: formData.rotaryRecognition,
        OnlineAccountwithmyRotary: formData.onlineAccountwithmyRotary,
        DateOfJoining: formData.admittedDate || null,
        AdmittedDate: formData.admittedDate || null,
        MemberId: formData.memberId || null,
        CategoryId: formData.category || null,

      };

      try {
        const response = await updateData('ProfileViewApi', formData.id, member, token);
        console.log('Record updated successfully:', response);

        setTimeout(() => {
          setSuccessMessage("");
        }, 3000);
        setIsEditModalOpen(!isEditModalOpen);
        //history.push('/MemberIndex');

      } catch (error) {
        console.error('Error updating record:', error);
      }
    };

  useEffect(() => {

    fetchMessages();
  }, []);

  const fetchMessages = async () => {
    try {
      const response = await fetchData1('ProfileViewApi', `/${branchId}`, token);
      const messagesData = Array.isArray(response.response_data) ? response.response_data : [response.response_data]; // If not an array, wrap it in one

      // Set the messages
      setMessages(messagesData);

    } catch (error) {
      console.error('Error fetching messages:', error);
    }
  };

  const handleSubmitChild
    = async (e) => {
      e.preventDefault();

      const familyMembers = {
        Name: newRecordData.name || null,
        Id: childId,
        ClubId: clubId,
        DateOfBirth: newRecordData.dateOfBirth || null,
        BloodGroupId: newRecordData.bloodGroupId || null,
        Relation: newRecordData.relation || null,
        CreatedBy: userId,  // Conditionally set CreatedBy
        CreatedDate: new Date(),  // Conditionally set CreatedDate
        ModifiedBy: userId,
        ModifiedDate: new Date(),

      };


      try {
        const response = await updateData('ProfileViewApi', `${childId}/${1}`, familyMembers, token);
        console.log('Record updated successfully:', response);

        toggleChildEditModalClose();
        setTimeout(() => {
          setSuccessMessage("");


        }, 3000);

        window.location.reload();

      } catch (error) {
        console.error('Error updating record:', error);
      }
    };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (file) {
      // Step 1: Preview image locally
      const localUrl = URL.createObjectURL(file);
      setProfilePhoto(localUrl);
      setSelectedFile(file);
      const guidnew = uuidv4();
      const publicId = `${firstname}_${id}_${guidnew}`;
      // Step 2: Upload the file to Cloudinary
      const formData1 = new FormData();
      formData1.append('file', file);
      formData1.append('upload_preset', 'testupload');  // Use your Cloudinary preset here
      formData1.append('folder', `Rotary/member/${branchId}`); // Optional: You can specify a folder for organization
      formData1.append('public_id', publicId); // Optional: Set a public ID for the image (you can generate a unique ID)

      try {
        const response = await axios.post('https://api.cloudinary.com/v1_1/dm9pk2viy/image/upload', formData1);

        // Step 3: Set the uploaded image URL to the state
        const uploadedImageUrl = response.data.secure_url;
        setUploadedImageUrl(uploadedImageUrl); // Set the uploaded image URL
        setUploadedImageName(file.name); // Store the file name or any other metadata

        // Optionally, if you want to update the profile photo to the uploaded image:
        //setProfilePhoto(uploadedImageUrl);
        setprofileguid(guidnew);
        const member = {
          Id: formData.id,
          FirstName: formData.firstName || null,  // Pass null if lastname is falsy
          LastName: formData.lastName || null,  // Pass null if firstname is falsy
          WeddingAnniversary: formData.weddingAnniversary || null,  // Null if weddinganniversary is falsy
          DateOfJoining: formData.dateOfJoining || null,  // Null if dateofjoining is falsy
          DateOfBirth: formData.dateOfBirth || null,  // Null if dateofbirth is falsy
          PhoneNumber: formData.phoneNumber || null,  // Null if phonenumber is falsy
          Email: formData.email || null,  // Null if email is falsy
          Remark: formData.remark || null,  // Null if remark is falsy
          CreatedBy: formData.createdBy, // Null if userId is falsy (unlikely for userId)
          CreatedDate: formData.createdDate,  // Always generate the current date
          ModifiedBy: userId,
          ModifiedDate: new Date(),
          BloodGroupId: formData.bloodGroupId,
          Gender: formData.gender || null,  // Null if gender is falsy
          ClubId: clubId, // Null if clubId is falsy
          UserTypeId: 4, // Default to 4 (doesn't need a null check)
          Expirydate: formData.expirydate,
          DateOfLeavingFrom: formData.expirydate,
          DateOfLeavingTo: formData.expirydate,
          IsLoginNeeded: true,
          Status: formData.status,
          profileguid: guidnew,
          MemberId: formData.memberId || null,
        };

        try {
          const response = await updateData('ProfileViewApi', formData.id, member, token);
          console.log('Record updated successfully:', response);

          setTimeout(() => {
            setSuccessMessage("");
          }, 3000);

          //history.push('/MemberIndex');

        } catch (error) {
          console.error('Error updating record:', error);
        }
        window.location.reload();
      } catch (error) {
        console.error('Error uploading image to Cloudinary:', error);
      }
    }
  };

  const handleCategoryChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value, // Update gender based on the selected value
    }));
  };

  const handleMemberChange = (selectedOption) => {
    setFormData((prevData) => ({
      ...prevData,
      proposedByMemberId: selectedOption ? selectedOption.value : null,  // Update formData with selected blood group
      memberName: selectedOption ? selectedOption.label : '',  // Optionally store the blood group name
    }));
  };

  const handleOnlineChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value, // Update gender based on the selected value
    }));
  };

  return (
    <div style={containerStyle}>

      <div style={cardStyle}>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-1%' }}>
          <Tooltip title="Edit Master Data"> <BorderColorIcon onClick={toggleMasterEditModal} style={{ color: '#89A8B2', marginTop: '-1.50%' }} /></Tooltip>
          <Tooltip title="Reminders"> <CircleNotificationsIcon onClick={toggleReminderModal} style={{ color: 'darkgoldenrod', marginLeft: '20px', marginTop: '-1.50%' }} /></Tooltip>
          <Tooltip title="Messages"> <MessageIcon onClick={toggleMessageModal} style={{ color: 'green', marginLeft: '20px', marginTop: '-1.50%' }} /></Tooltip>

        </div>

        {/* Picture Box Section */}
        <div
          style={{
            width: '100px',
            height: '80px',
            padding: '8px',
            border: '2px solid #ccc',
            borderRadius: '10px',
            backgroundColor: '#fafafa',
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'hidden',
            cursor: 'pointer',
            marginLeft: '42.5%',
            marginTop: '1.50%'
          }}
          onClick={() => document.getElementById('fileInput').click()} // Triggers file input on image click
        >
          <div className="flex flex-col items-center" >
            <input
              type="file"
              accept="image/*"
              id="fileInput"
              onChange={handleFileUpload}
              style={{ display: 'none' }} // Hide the actual file input
            />
            <div>
              {profilePhoto ? (
                <img
                  src={profilePhoto}
                  alt="Selected"
                  style={{
                    objectFit: 'cover', // Ensures the image covers the container without distortion
                    width: '100%',
                    height: '100%', // Makes the image fit the box size
                  }}
                  id="fileInput"
                />
              ) : (
                <span>No photo uploaded</span>
              )}
            </div>
            {uploadedImageName && <p style={{ fontSize: '12px', marginTop: '5px' }}>Uploaded Image: {uploadedImageName}</p>}
            {uploadedImageUrl && (
              <img
                src={uploadedImageUrl}
                alt="Uploaded"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            )}
          </div>
        </div>
        <h4 style={{ marginTop: '7px' }}>
          <span
            style={{
              color: 'darkblue',
              fontFamily: 'italic',
              animation: isFirstLogin ? 'fadeIn 2s' : 'none',
            }}
          >
            {isFirstLogin ? (
              <>
                Welcome,{' '}
                <span style={{ color: 'darkblue', fontFamily: 'italic' }}>
                  {formData.firstName} {formData.lastName}
                </span>
              </>
            ) : (
              <>
                {formData.firstName} {formData.lastName}
              </>
            )}
          </span>
        </h4>

        <p style={{ ...subtitleStyle, marginTop: '-1.50%' }}>{formData.email} , {formData.phoneNumber}</p>
        <p style={subtitleStyle}>{formData.remark}</p>

        <hr />
        <p style={{ ...bioStyle, marginTop: '-1.50%', marginBottom: 0 }}>
          <strong></strong>Hello, {formData.firstName} {formData.lastName}, You started the journey with Rotary
          Club since <span style={{ color: 'red', fontWeight: 'bold' }}> "{formatDateForInput(formData.dateOfJoining)}" </span>.
        </p>
      </div>

      <div style={{ backgroundColor: 'white', borderRadius: '10px', marginTop: '-2.00%' }}>
        <h5 style={nameStyle}><span style={{ fontWeight: 'bold', fontFamily: 'italic', color: 'brown' }}>   <PeopleAltIcon style={{ color: 'black' }} /> Family Members</span></h5>
        <table style={tableStyle}>
          <thead style={{ backgroundColor: 'whitesmoke' }}>
            <tr>
              <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '4px' }}>Sl No</TableCell>
              <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '4px' }}>Name</TableCell>
              <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '4px' }}>DOB</TableCell>
              <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '4px' }}>Relation</TableCell>
              <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '4px' }}>Edit</TableCell>
            </tr>
          </thead>
          <TableBody>
            {MemberFamilyDatas.map((childdata, index) => (
              <TableRow key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? '#F7FAFF' : '#FFFFFF',
                  borderBottom: '1px solid #E0E0E0',
                  transition: 'transform 0.2s ease-in-out',
                  cursor: 'pointer',
                }}
                onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
                onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
              >
                <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '5px' }}>{index + 1}</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '5px' }}>{childdata.name}</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '5px' }}>
                  {formatDateForInput(childdata.dateOfBirth)}
                </TableCell>
                <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '5px' }}>{childdata.relation}</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '2px' }}>{childdata.remarks}

                  <Tooltip title="Edit Familydata">
                    <IconButton onClick={() => toggleChildEditModal(childdata.id, childdata)} aria-label="edit" size="small">
                      <EditIcon style={{ color: 'teal', fontSize: '20px', fontWeight: 'bold' }} />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </table>

      </div>
      {isMessageModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-10">
          <div
            className="bg-white p-6 rounded-lg shadow-lg"
            style={{
              width: '90%', // Adjust width for responsiveness
              maxWidth: '600px',
              height: '550px',
              overflowY: 'auto',
            }}
          >
            {/* Header */}
            <div className="flex justify-between items-center">
              <h6 className="text-xl font-semibold text-darkblue">Chat</h6>
              <button
                className="bg-red-500 text-white text-sm px-2 py-1 rounded-full"
                onClick={() => setIsMessageModalOpen(false)}
              >
                X
              </button>
            </div>

            <div
              className="mt-6"
              style={{
                maxHeight: '400px',
                overflowY: 'auto',
                maxWidth: '100%',
              }}
            >
              {messages && messages.length > 0 ? (
                messages.map((message, index) => (
                  <div
                    key={index}
                    style={{
                      backgroundColor: '#f9f9f9',
                      borderRadius: '8px',
                      padding: '15px',
                      margin: '10px 0',
                      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                      display: 'flex',
                      flexDirection: 'column',
                      fontFamily: 'Arial, sans-serif',
                      maxWidth: '100%', // Ensures message card is responsive
                      textAlign: 'left',
                      wordBreak: 'break-word', // Prevents long words from overflowing
                      wordWrap: 'break-word', // Ensures text wraps in the card
                    }}
                  >
                    <strong
                      style={{
                        fontSize: '12px',
                        color: '#333',
                        marginBottom: '5px',
                      }}
                    >
                      {message.userName || 'No Name'} - {message.phoneNo || 'No Phone'}
                    </strong>

                    <p
                      style={{
                        color: '#333',
                        marginTop: '0',
                        fontSize: '12px',
                        wordBreak: 'break-word', // Ensures long messages break to fit within the card
                      }}
                    >
                      {message.message || 'No message available'}
                    </p>
                  </div>
                ))
              ) : (
                <p>No messages available</p>
              )}
            </div>

            {/* Message Input */}
            <div style={{ borderBottom: '0px', bottom: '0' }}>
              <input
                className="shadow appearance-none border rounded py-2 px-3 text-gray-700"
                type="text"
                placeholder="Type a message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                onKeyDown={handleKeyPress}
                style={{ width: '70%' }}
              />
              <button
                className="bg-blue-500 text-white text-sm px-4 py-2 rounded-full"
                onClick={handleSendMessage}
                disabled={isMessageSending}
                style={{ marginLeft: '15px' }}
              >
                Send
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Confirmation Modal */}
      {isConfirmModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-20 bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-lg shadow-lg">
            <h3 className="text-xl">Are you sure you want to send this message?</h3>
            <div className="mt-4 flex justify-between">
              <button
                className="bg-red-500 text-white px-4 py-2 rounded-full"
                onClick={() => handleConfirmSend(false)}
              >
                No
              </button>
              <button
                className="bg-green-500 text-white px-4 py-2 rounded-full"
                onClick={() => handleConfirmSend(true)}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}

      {
        isReminderModalOpen && (
          <div className="fixed inset-0 flex items-center justify-center z-10">
            <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '600px', height: '550px', overflow: 'auto' }}>

              {/* Header Row */}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  width: '100%',
                  gap: '10px',
                }}
              >
                <h6
                  className="text-xl font-semibold"
                  style={{
                    fontWeight: 'bold',
                    fontFamily: 'italic',
                    color: 'darkblue',
                    margin: 0,
                    flex: '1',
                  }}
                >
                  Events
                </h6>
                <label>Remind</label>
                <input
                  className="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                  value={interval}
                  onChange={(e) => setInterval(e.target.value)}
                  type="text"
                  placeholder="Interval"
                  style={{
                    width: '100px',
                    textAlign: 'center',
                    flexShrink: 0,
                  }}
                /><label>days prior to event</label>

                <button
                  className="bg-red-500 text-white text-sm px-2 py-1 rounded-full"
                  onClick={toggleReminderModalClose}
                  style={{
                    marginTop: '0',
                    flexShrink: 0,
                  }}
                >
                  X
                </button>
              </div>

              <div className="space-y-4">
                {data
                  //.filter((reminder) => new Date(reminder.happeningon) <= new Date(fromdate))
                  .map((reminder, index) => (
                    <div
                      key={index}
                      className={`flex items-center p-4 rounded-lg shadow-md } text-white`}
                      style={{
                        margin: '7px',
                        height: 'auto',
                        backgroundColor: ['#FBF6E9', '#C9E6F0', '#B9E5E8', '#FFE3E3', '#C4DAD2'][Math.floor(Math.random() * 5)]
                      }}
                    >
                      <div
                        className="flex-shrink-0 mb-2 sm:mb-0 sm:mr-4"
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginBottom: '10px',
                        }}
                      >
                        <CalendarMonthIcon
                          className="w-12 h-12"
                          style={{ color: 'red', width: '30px', height: '30px' }}
                        />
                      </div>
                      <div style={{ textAlign: 'center', width: '100%' }}>
                        <h5
                          className="font-semibold text-lg"
                          style={{ color: 'black', fontSize: '14px', marginBottom: '5px' }}
                        >
                          {reminder.event}
                        </h5>
                        <p
                          className="text-sm"
                          style={{ color: 'black', fontSize: '13px', wordWrap: 'break-word' }}
                        >
                          {reminder.member} - {formatDateForInput(reminder.happeningon)}
                        </p>

                      </div>
                    </div>
                  ))}
              </div>

            </div>
          </div>
        )
      }

      {
        isEditModalOpen && (
          <div className="fixed inset-0 flex items-center justify-center z-10">
            {/* <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '700px', height: '400', overflowY: 'auto' }}> */}
            <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '70%', height: '600px', overflowY: 'auto' }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  width: '100%',
                  gap: '10px',
                }}
              >
                <h6
                  className="text-xl font-semibold"
                  style={{
                    fontWeight: 'bold',
                    fontFamily: 'italic',
                    color: 'darkblue',
                    margin: 0,
                    flex: '1',
                  }}
                >
                  Edit User
                </h6>

                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>

                  <button
                    className="bg-green-500 text-white text-sm px-2 py-1 rounded-full flex items-center"
                    onClick={handleSubmitMaster} // You can replace `handleSave` with your actual function to handle save
                    style={{
                      marginTop: '0',
                      flexShrink: 0,
                    }}
                  >
                    <FaSave className="mr-2"

                      style={{ fontSize: '16px' }} /> Update
                  </button>

                  <button
                    className="bg-red-500 text-white text-sm px-2 py-1 rounded-full"
                    onClick={toggleEditModalClose}
                    style={{
                      marginTop: '0',
                      flexShrink: 0,
                    }}
                  >
                    X
                  </button>
                </div>
              </div>

              <div className="space-y-4">
                <div className="w-full grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2">
                  <div>
                    <label htmlFor="memberId">Member Id
                      <span className="text-red-500 ml-1">*</span>
                    </label>
                    <input
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                      name="memberId"
                      value={formData.memberId}
                      onChange={handleChange}
                      type="text"

                    />
                  </div>

                  <div className="flex flex-col">
                    <label className="text-sm font-medium">Category
                      <select
                        name="category"
                        value={formData.category}
                        onChange={handleCategoryChange}
                        className="form-select block w-full py-2 px-3 border border-gray-300 rounded-md text-sm"
                      >
                        <option value="1">General</option>
                        <option value="2">Honorary</option>
                        <option value="3">Emeritus</option>
                        <option value="4">Corporate</option>

                      </select>
                    </label>
                  </div>

                  <div>
                    <label htmlFor="name">First Name
                      <span className="text-red-500 ml-1">*</span>
                    </label>
                    <input
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      type="text"
                      placeholder="Enter Name"
                      disabled={!isIdValid}
                    />
                  </div>
                  <div>
                    <label htmlFor="Last Name">Last Name
                      <span className="text-red-500 ml-1">*</span>
                    </label>
                    <input
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      type="text"
                      placeholder="Enter Last Name"
                      disabled={!isIdValid}
                    />
                  </div>
                </div>
                <div className="w-full grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2">
                  <div>
                    <label htmlFor="code">Email
                      <span className="text-red-500 ml-1">*</span>
                    </label>
                    <input
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      type="text"
                      placeholder="Enter Email"
                      disabled={!isIdValid}
                    />
                  </div>

                  <div>
                    <label htmlFor="code">Phone No(Country Code)
                      <span className="text-red-500 ml-1">*</span>
                    </label>
                    <input
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                      name="phoneNumber"
                      value={formData.phoneNumber}
                      onChange={handleChange}
                      type="text"
                      placeholder="Enter Phone Number"
                      disabled={!isIdValid}
                    />
                  </div>

                  <div>
                    <label htmlFor="code">Phone No(Whats App)
                      <span className="text-red-500 ml-1">*</span>
                    </label>
                    <input
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                      name="phoneNumber1"
                      value={formData.phoneNumber1}
                      onChange={handleChange}
                      type="text"
                      placeholder="Enter Phone Number"
                      disabled={!isIdValid}
                    />
                  </div>

                  <div>
                    <label htmlFor="code">Date of Birth
                      <span className="text-red-500 ml-1">*</span>
                    </label>
                    <input
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                      name="dateOfBirth"
                      value={formatDateForInput(formData.dateOfBirth)}
                      onChange={handleChange}
                      type="date"
                      placeholder="Enter Date of Birth"
                      disabled={!isIdValid}
                    />

                  </div>
                </div>
                <div className="w-full grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2">
                  <div>
                    <label htmlFor="admittedDate">Admitted Date
                      <span className="text-red-500 ml-1">*</span>
                    </label>
                    <input
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                      name="admittedDate"
                      value={formatDateForInput(formData.admittedDate)}
                      onChange={handleChange}
                      type="date"
                      placeholder="Enter Admitted Date"
                      disabled={!isIdValid}
                    />
                  </div>
                  <div>
                    <label htmlFor="code">Wedding Anniversary</label>
                    <input
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                      name="weddingAnniversary"
                      value={formatDateForInput(formData.weddingAnniversary)}
                      onChange={handleChange}
                      type="date"
                      placeholder="Enter Wedding Anniversary"
                      disabled={!isIdValid}
                    />
                  </div>


                  <div>
                    <label htmlFor="originalRotaryDate">Rotary Date</label>
                    <input
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                      name="originalRotaryDate"
                      value={formatDateForInput(formData.originalRotaryDate)}
                      onChange={handleChange}
                      type="date"
                      placeholder="Enter Rotary Date"
                      disabled={!isIdValid}
                    />
                  </div>
                  <div >
                    <label htmlFor="bloodGroup">Proposed Member</label>

                    <Select
                      value={formData.proposedByMemberId ? { value: formData.proposedByMemberId, label: formData.memberName } : null}  // Set the value correctly
                      onChange={handleMemberChange}
                      options={memberlist}
                      placeholder="Select Member"
                      isSearchable
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        menu: (base) => ({ ...base, zIndex: 9999 }),
                        control: (base) => ({
                          ...base,
                          width: '100%',
                          minHeight: '38px',
                          border: '1px solid #D1D5DB',
                          borderRadius: '6px',
                          padding: '2px 3px',
                          fontSize: '14px'
                        })
                      }}
                    />
                  </div>
                </div>

                <div className="w-full grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2">

                  <div>
                    <label htmlFor="classification">Classification</label>
                    <input
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                      name="classification"
                      value={formData.classification}
                      onChange={handleChange}
                      type="text"
                      placeholder="Enter Classification"
                      disabled={!isIdValid}
                    />
                  </div>
                  <div>
                    <label htmlFor="firmName">Firm Name</label>
                    <input
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                      name="firmName"
                      value={formData.firmName}
                      onChange={handleChange}
                      type="text"
                      placeholder="Enter Firm Name"
                      disabled={!isIdValid}
                    />
                  </div>
                  <div>
                    <label htmlFor="occupation">Profession / Bussiness</label>
                    <input
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                      name="occupation"
                      value={formData.occupation}
                      onChange={handleChange}
                      type="text"
                      placeholder="Enter Profession / Bussiness"
                      disabled={!isIdValid}
                    />
                  </div>

                  <div>

                    <label htmlFor="address">Address</label>

                    <input
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                      type="text"
                      placeholder="Enter Address"
                      disabled={!isIdValid}
                    />

                  </div>


                </div>

                <div className="w-full grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2">
                  <div>
                    <label htmlFor="city">City</label>
                    <input
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                      name="city"
                      value={formData.city}
                      onChange={handleChange}
                      type="text"
                      placeholder="Enter City"
                      disabled={!isIdValid}
                    />
                  </div>
                  <div>
                    <label htmlFor="state">State</label>
                    <input
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                      name="state"
                      value={formData.state}
                      onChange={handleChange}
                      type="text"
                      placeholder="Enter State"
                      disabled={!isIdValid}
                    />
                  </div>
                  <div>
                    <label htmlFor="country">Country</label>
                    <input
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                      name="country"
                      value={formData.country}
                      onChange={handleChange}
                      type="text"
                      placeholder="Enter Country"
                      disabled={!isIdValid}
                    />
                  </div>
                  <div>
                    <label htmlFor="postalCode">Postal Code</label>
                    <input
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                      name="postalCode"
                      value={formData.postalCode}
                      onChange={handleChange}
                      type="text"
                      placeholder="Enter Postal Code"
                      disabled={!isIdValid}
                    />
                  </div>

                </div>
                <div className="w-full grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-2">
                  {/* Rotary Recognitions */}
                  <div className="flex flex-col">
                    <label htmlFor="rotaryRecognition" className="text-sm font-medium">Rotary Recognitions</label>
                    <select
                      name="rotaryRecognition"
                      value={formData.rotaryRecognition}
                      onChange={handleChange}
                      className="form-select block w-full py-2 px-3 border border-gray-300 rounded-md text-sm"
                    >
                      <option value="1">PHF</option>
                      <option value="2">AKS</option>
                      <option value="3">MD</option>
                    </select>
                  </div>

                  {/* Online Account */}
                  <div className="flex flex-col">
                    <label htmlFor="onlineAccount" className="text-sm font-medium">Online Account</label>
                    <select
                      name="onlineAccountwithmyRotary"
                      value={formData.onlineAccountwithmyRotary}
                      onChange={handleOnlineChange}
                      className="form-select block w-full py-2 px-3 border border-gray-300 rounded-md text-sm"
                    >
                      <option value="1">Yes</option>
                      <option value="2">No</option>
                    </select>
                  </div>

                  {/* Gender */}
                  <div className="flex flex-col">
                    <label htmlFor="gender" className="text-sm font-medium">Gender</label>
                    <select
                      name="gender"
                      value={formData.gender}
                      onChange={handleGenderChange}
                      className="form-select block w-full py-2 px-3 border border-gray-300 rounded-md text-sm"
                    >
                      <option value="1">Male</option>
                      <option value="2">Female</option>
                      <option value="3">Others</option>
                    </select>
                  </div>

                  {/* Blood Group */}
                  <div className="flex flex-col">
                    <label htmlFor="bloodGroup" className="text-sm font-medium  text-left">Blood Group</label>
                    <Select
                      // value={formData.bloodGroupName ? { value: formData.bloodGroupId, label: formData.bloodGroupName } : null}
                      value={selectedgroup || (formData.bloodGroupName ? { value: formData.bloodGroupId, label: formData.bloodGroupName } : '')}
                      onChange={handleBloodGroupChange}
                      options={bloodGroupOptions}
                      placeholder="Select Blood Group"
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        menu: (base) => ({ ...base, zIndex: 9999 }),
                        control: (base) => ({
                          ...base,
                          width: '100%',
                          minHeight: '38px',
                          border: '1px solid #D1D5DB',
                          borderRadius: '6px',
                          padding: '2px 3px',
                          fontSize: '14px'
                        })
                      }}
                    />
                  </div>

                  {/* Status */}
                  <div className="flex flex-col">
                    <label htmlFor="status" className="text-sm font-medium">Status</label>
                    <select
                      name="status"
                      value={formData.status}
                      onChange={handleChange}
                      className="form-select block w-full py-2 px-3 border border-gray-300 rounded-md text-sm"
                    >
                      <option value="1">Active</option>
                      <option value="2">On-Leave</option>
                      <option value="3">Ex-Member</option>
                    </select>
                  </div>
                </div>

                <div className="w-full grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-1 gap-2">
                  <div>
                    <label htmlFor="code">Remark</label>
                    <input
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                      name="remark"
                      value={formData.remark}
                      onChange={handleChange}
                      type="text"
                      placeholder="Enter Remarks"
                      disabled={!isIdValid}
                    />
                  </div>



                </div>

              </div>

            </div>
          </div>
        )
      }


















      {
        isModalOpen && (
          <div className="fixed inset-0 flex items-center justify-center z-10">
            <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '700px', height: 'auto', overflow: 'auto' }}>


              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  width: '100%',
                  gap: '10px',
                }}
              >
                <h6
                  className="text-xl font-semibold"
                  style={{
                    fontWeight: 'bold',
                    fontFamily: 'italic',
                    color: 'darkblue',
                    margin: 0,
                    flex: '1',
                  }}
                >
                  Edit Family Member
                </h6>

                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>

                  <button
                    className="bg-green-500 text-white text-sm px-2 py-1 rounded-full flex items-center"
                    onClick={handleSubmitChild} // You can replace `handleSave` with your actual function to handle save
                    style={{
                      marginTop: '0',
                      flexShrink: 0,
                    }}
                  >
                    <FaSave className="mr-2"

                      style={{ fontSize: '16px' }} />Update
                  </button>

                  <button
                    className="bg-red-500 text-white text-sm px-2 py-1 rounded-full"
                    onClick={toggleChildEditModalClose}
                    style={{
                      marginTop: '0',
                      flexShrink: 0,
                    }}
                  >
                    X
                  </button>
                </div>
              </div>


              <div className="space-y-4">
                <div className="w-full grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
                  <div>

                    <label htmlFor="name">Name</label>
                    <input
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                      type="text"
                      name="name"
                      placeholder="Enter Name"
                      value={newRecordData.name}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div>
                    <label htmlFor="dateofbirth">Date Of Birth</label>
                    <input
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                      type="text"
                      name="dateOfBirth"
                      value={formatDateForInput(newRecordData.dateOfBirth)}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div>
                    <label htmlFor="bloodGroup">Blood Group</label>
                    <Select
                      value={newRecordData.bloodGroupId ? bloodGroupOptions.find(option => option.value === newRecordData.bloodGroupId) : null}  // Find the selected value
                      onChange={(selectedOption) => setNewRecordData(prevData => ({
                        ...prevData,
                        bloodGroupId: selectedOption ? selectedOption.value : null
                      }))}  // Update the bloodGroupId in the child data
                      options={bloodGroupOptions}  // Use the same options as master
                      placeholder="Select Blood Group"
                      isSearchable
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        menu: (base) => ({ ...base, zIndex: 9999 }),
                        control: (base) => ({
                          ...base,
                          width: '100%',
                          minHeight: '38px',
                          border: '1px solid #D1D5DB',
                          borderRadius: '6px',
                          padding: '2px 3px',
                          fontSize: '14px'
                        })
                      }}
                    />
                  </div>
                </div>

                <div className="w-full grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2">
                  <div>
                    <label htmlFor="relation">Relation</label>
                    <input
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                      type="text"
                      name="relation"
                      placeholder="Enter Relation"
                      value={newRecordData.relation}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      }



    </div >
  )
}


export default Home1;